<template>
    <div :class="portalContentAndDesignStore.getPageContainerClasses">
        <div>
            <div id="partner-login">

                <regular-form v-if="!portalContentAndDesignStore.loginPageSettings.is_otp_login" />
                <otp-ini-form v-else />

                <editable-btn
                    :prevent-double-click="5000"
                    size="huge"
                    class="w-full"
                    :type="buttonType"
                    v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login"
                    :loading="portalContentAndDesignStore.loggingInProgress"
                    :disabled="portalContentAndDesignStore.loggingInProgress"
                    @click="submitLogin"
                >
                    {{ portalContentAndDesignStore.translationSettings.portal_translation_login_login }}
                </editable-btn>

                <!-- Social Auth -->
                <template v-if="portalContentAndDesignStore.portalLayoutSettings.portal_affiliate_enable_partners_to_login_signup_via_google">
                    <div class="flex flex-row items-center justify-center my-4">
                        <div class="w-full">
                            <hr>
                        </div>
                        <div class="px-4">
                            <editable-text-field
                                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_or"
                                class="block text-sm opacity-80 mb-1.5"
                                :class="portalContentAndDesignStore.getPageContentTextColorClass"
                                text-type="span"
                            >
                            </editable-text-field>
                        </div>
                        <div class="w-full">
                            <hr>
                        </div>
                    </div>

                    <editable-social-auth-btn
                        social-provider="google"
                        :social-submit-url="portalContentAndDesignStore.isPreview ? '#' : portalContentAndDesignStore.getSocialAuthLoginRedirectRoute('google')"
                        v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_login_with_google"
                    />
                </template>
            </div>
        </div>
        <!-- Register section -->
        <div v-if="!portalContentAndDesignStore.portalLayoutSettings.referral_portal_portal_disable_registrations_via_portal"
             :class="[
                'flex space-x-1 pt-6 text-sm justify-center',
                 portalContentAndDesignStore.getPageContentTextColorClass
             ]">

            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_not_registered"
                text-type="span"
            />

            <editable-text-field
                v-model="portalContentAndDesignStore.translationSettings.portal_translation_login_create_account"
                text-type="a"
                :href="portalContentAndDesignStore.isPreview ? '#' : portalContentAndDesignStore.getRegisterRoute"
                :class="[
                    'text-opacity-100 hover:underline',
                    portalContentAndDesignStore.getLinkColorClass
                ]"
            />
        </div>
    </div>
</template>

<script setup>
import {computed} from "vue";
import {usePortalContentAndDesignStore} from "../../../../../stores/partners/portalContentAndDesignStore";
import RegularForm from "./Partial/Affiliate/RegularForm.vue";
import OtpIniForm from "./Partial/Affiliate/OtpIniForm.vue";
import EditableBtn from "../../../portal-editable-fields/EditableBtn.vue";
import EditableTextField from "../../../portal-editable-fields/EditableTextField.vue";
import EditableSocialAuthBtn from "../../../portal-editable-fields/EditableSocialAuthBtn.vue";
import {useLogin} from "../../../../../composables/partners/useLogin";

const portalContentAndDesignStore = usePortalContentAndDesignStore();

const buttonType = computed(() => {
    return portalContentAndDesignStore.getPageContentButtonColorClass
});

const { submitLogin } = useLogin();
</script>
